<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate [formGroup]="StudentEdit">
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <!-- Page Header -->
                    <div class="page-header">
                        <div>
                            <h2 class="main-content-title tx-24 mg-b-5">All Student Records</h2>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">Student Data</li>
                            </ol>
                        </div>

                    </div>


                    <!-- <div >
                        <mat-tree [dataSource]="dataSource2" [treeControl]="treeControl" class="example-tree">
                          <mat-tree-node class="" *matTreeNodeDef="let node" matTreeNodeToggle>
                            </mat-tree-node>
                          <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                              <div class="mat-tree-node">
                                <button mat-icon-button matTreeNodeToggle
                                        [attr.aria-label]="'Toggle ' + node.name">
                                  <mat-icon class="mat-icon-rtl-mirror">
                                    {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}                               </mat-icon>
                                </button>
                                {{node.name}}
                              </div>
                              <div [class.example-tree-invisible]="!treeControl.isExpanded(node)"
                                  role="group">
                                <ng-container matTreeNodeOutlet>
                                   
                                </ng-container>
                            </div>
                          </mat-nested-tree-node>
                        </mat-tree>
                      </div> -->

                    <mat-accordion>
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Student Details
                                </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead >
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <!-- <th class="f600">
                                        Pattern
                                    </th> -->
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data">
                                        <tr *ngFor="let value of Arr;">

                                            <td width="20%"> {{value.name}} </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control"
                                                    value="{{value.display}}">
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormRequired">
                                                        <mat-option value="Yes">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option value="No">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormVisible"
                                                        (selectionChange)="add($event,value)">
                                                        <mat-option value="Yes">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option value="No">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>

                                            <!-- <td width="30%">
                                        <input formControlName="pattern" class="form-control" value="{{value.pattern}}">
                                    </td> -->
                                            <!-- <td class="text-center">
    
                                        <a class="btn-floating" (click)="add()">
                                            <i class="fa fa-plus" ></i>
                                        </a>
                                        <a class="btn-floating" (click)="delete()">
                                            <i class="fas fa-trash" ></i>
                                        </a>
                                    </td> -->
                                        </tr>
                                    </tbody>

                                </table>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="next()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button>
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Personal Details
                                </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <!-- <th class="f600">
                                        Pattern
                                    </th> -->
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" >
                                        <tr 
                                        *ngFor="let pdetail of PersonalDetail;">

                                            <td width="20%">
                                                <mat-label formControlName="FormName">{{pdetail.name}}</mat-label>
                                                <!-- {{pdetail.name}}  -->
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control"
                                                    value="{{pdetail.display}}">
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormRequired">
                                                        <mat-option value="Yes">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option value="No">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormVisible"
                                                        (selectionChange)="add($event,pdetail)">
                                                        <mat-option value="Yes">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option value="No">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>

                                            <!-- <td width="30%">
                                        <input formControlName="pattern" class="form-control" value="{{value.pattern}}">
                                    </td> -->
                                            <!-- <td class="text-center">
    
                                        <a class="btn-floating" (click)="add()">
                                            <i class="fa fa-plus" ></i>
                                        </a>
                                        <a class="btn-floating" (click)="delete()">
                                            <i class="fas fa-trash" ></i>
                                        </a>
                                    </td> -->
                                        </tr>
                                    </tbody>

                                </table>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save1()">Save</button>
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Contact Details
                                </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <!-- <th class="f600">
                                        Pattern
                                    </th> -->
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data">
                                        <tr *ngFor="let cdetail of ContactDetail;">

                                            <td width="20%">
                                                <mat-label formControlName="FormName">{{cdetail.name}}</mat-label>
                                                <!-- {{cdetail.name}}  -->
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control"
                                                    value="{{cdetail.display}}">
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormRequired">
                                                        <mat-option value="Yes">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option value="No">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormVisible"
                                                        (selectionChange)="add($event,cdetail)">
                                                        <mat-option value="Yes">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option value="No">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>

                                            <!-- <td width="30%">
                                        <input formControlName="pattern" class="form-control" value="{{value.pattern}}">
                                    </td> -->
                                            <!-- <td class="text-center">
    
                                        <a class="btn-floating" (click)="add()">
                                            <i class="fa fa-plus" ></i>
                                        </a>
                                        <a class="btn-floating" (click)="delete()">
                                            <i class="fas fa-trash" ></i>
                                        </a>
                                    </td> -->
                                        </tr>
                                    </tbody>

                                </table>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button>
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Reservation Details
                                </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <!-- <th class="f600">
                                        Pattern
                                    </th> -->
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data">
                                        <tr *ngFor="let regdetail of RegisterDetail;">

                                            <td width="20%">
                                                <mat-label formControlName="FormName">{{regdetail.name}}</mat-label>
                                                <!-- {{regdetail.name}}  -->
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control"
                                                    value="{{regdetail.display}}">
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormRequired">
                                                        <mat-option value="Yes">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option value="No">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormVisible"
                                                        (selectionChange)="add($event,regdetail)">
                                                        <mat-option value="Yes">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option value="No">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>

                                            <!-- <td width="30%">
                                        <input formControlName="pattern" class="form-control" value="{{value.pattern}}">
                                    </td> -->
                                            <!-- <td class="text-center">
    
                                        <a class="btn-floating" (click)="add()">
                                            <i class="fa fa-plus" ></i>
                                        </a>
                                        <a class="btn-floating" (click)="delete()">
                                            <i class="fas fa-trash" ></i>
                                        </a>
                                    </td> -->
                                        </tr>
                                    </tbody>

                                </table>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button>
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Qualification Details
                                </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <!-- <th class="f600">
                                        Pattern
                                    </th> -->
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data">
                                        <tr *ngFor="let quadetail of QualificationDetail;">

                                            <td width="20%">
                                                <mat-label formControlName="FormName">{{quadetail.name}}</mat-label>
                                                 <!-- {{quadetail.name}}  -->
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control"
                                                    value="{{quadetail.display}}">
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormRequired">
                                                        <mat-option value="Yes">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option value="No">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormVisible"
                                                        (selectionChange)="add($event,quadetail)">
                                                        <mat-option value="Yes">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option value="No">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>

                                            <!-- <td width="30%">
                                        <input formControlName="pattern" class="form-control" value="{{value.pattern}}">
                                    </td> -->
                                            <!-- <td class="text-center">
    
                                        <a class="btn-floating" (click)="add()">
                                            <i class="fa fa-plus" ></i>
                                        </a>
                                        <a class="btn-floating" (click)="delete()">
                                            <i class="fas fa-trash" ></i>
                                        </a>
                                    </td> -->
                                        </tr>
                                    </tbody>

                                </table>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button>
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Additional Details
                                </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <!-- <th class="f600">
                                        Pattern
                                    </th> -->
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data">
                                        <tr *ngFor="let addetail of AdditionalDetail;">

                                            <td width="20%">
                                                <mat-label formControlName="FormName">{{addetail.name}}</mat-label>
                                                 <!-- {{addetail.name}}  -->
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control"
                                                    value="{{addetail.display}}">
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormRequired">
                                                        <mat-option value="Yes">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option value="No">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormVisible"
                                                        (selectionChange)="add($event,addetail)">
                                                        <mat-option value="Yes">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option value="No">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>

                                            <!-- <td width="30%">
                                        <input formControlName="pattern" class="form-control" value="{{value.pattern}}">
                                    </td> -->
                                            <!-- <td class="text-center">
    
                                        <a class="btn-floating" (click)="add()">
                                            <i class="fa fa-plus" ></i>
                                        </a>
                                        <a class="btn-floating" (click)="delete()">
                                            <i class="fas fa-trash" ></i>
                                        </a>
                                    </td> -->
                                        </tr>
                                    </tbody>

                                </table>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button>
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Photo & Signature
                                </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <!-- <th class="f600">
                                        Pattern
                                    </th> -->
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data">
                                        <tr *ngFor="let photoS of PhotoSign;">

                                            <td width="20%">
                                                <mat-label formControlName="FormName">{{photoS.name}}</mat-label>
                                                 <!-- {{photoS.name}}  -->
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control"
                                                    value="{{photoS.display}}">
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormRequired">
                                                        <mat-option value="Yes">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option value="No">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormVisible"
                                                        (selectionChange)="add($event,photoS)">
                                                        <mat-option value="Yes">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option value="No">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>

                                            <!-- <td width="30%">
                                        <input formControlName="pattern" class="form-control" value="{{value.pattern}}">
                                    </td> -->
                                            <!-- <td class="text-center">
    
                                        <a class="btn-floating" (click)="add()">
                                            <i class="fa fa-plus" ></i>
                                        </a>
                                        <a class="btn-floating" (click)="delete()">
                                            <i class="fas fa-trash" ></i>
                                        </a>
                                    </td> -->
                                        </tr>
                                    </tbody>

                                </table>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button>
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Admission Details
                                </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <!-- <th class="f600">
                                        Pattern
                                    </th> -->
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data">
                                        <tr *ngFor="let admdetail of AdmissionDetail;">

                                            <td width="20%">
                                                <mat-label formControlName="FormName">{{admdetail.name}}</mat-label>
                                                 <!-- {{admdetail.name}}  -->
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control"
                                                    value="{{admdetail.display}}">
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormRequired">
                                                        <mat-option value="Yes">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option value="No">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormVisible"
                                                        (selectionChange)="add($event,admdetail)">
                                                        <mat-option value="Yes">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option value="No">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>

                                            <!-- <td width="30%">
                                        <input formControlName="pattern" class="form-control" value="{{value.pattern}}">
                                    </td> -->
                                            <!-- <td class="text-center">
    
                                        <a class="btn-floating" (click)="add()">
                                            <i class="fa fa-plus" ></i>
                                        </a>
                                        <a class="btn-floating" (click)="delete()">
                                            <i class="fas fa-trash" ></i>
                                        </a>
                                    </td> -->
                                        </tr>
                                    </tbody>

                                </table>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button>
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Document Upload
                                </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <!-- <th class="f600">
                                        Pattern
                                    </th> -->
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data">
                                        <tr *ngFor="let doc of Document;">

                                            <td width="20%">
                                                <mat-label formControlName="FormName">{{doc.name}}</mat-label>
                                                 <!-- {{doc.name}}  -->
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control"
                                                    value="{{doc.display}}">
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormRequired">
                                                        <mat-option value="Yes">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option value="No">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormVisible"
                                                        (selectionChange)="add($event,doc)">
                                                        <mat-option value="Yes">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option value="No">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>

                                            <!-- <td width="30%">
                                        <input formControlName="pattern" class="form-control" value="{{value.pattern}}">
                                    </td> -->
                                            <!-- <td class="text-center">
    
                                        <a class="btn-floating" (click)="add()">
                                            <i class="fa fa-plus" ></i>
                                        </a>
                                        <a class="btn-floating" (click)="delete()">
                                            <i class="fas fa-trash" ></i>
                                        </a>
                                    </td> -->
                                        </tr>
                                    </tbody>

                                </table>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>

                </div>
            </div>
        </div>
    </form>
</body>